import React from 'react';
import TagList from '../shared/TagList';
import MangaGenresSection from './MangaGenresSection';
import MangaThemesSection from './MangaThemesSection';

const MangaAbout = ({ manga }) => {
  // Add debug logging to help identify the data structure
  console.log('Manga data:', manga);
  console.log('Genres:', manga.genres);
  console.log('Themes:', manga.themes);

  // Create general information details
  const generalInfoDetails = [
    { label: "Type", value: manga.type || 'N/A' },
    { label: "Status", value: manga.status || 'N/A' },
    { label: "Demographics", value: 
      Array.isArray(manga.demographics) 
        ? manga.demographics.map(d => typeof d === 'string' ? d : d.name).join(', ')
        : 'N/A' 
    }
  ];

  return (
    <div className="manga-tab-content">
      <div className="manga-left-column">
        <div className="manga-synopsis">
          <h3>Synopsis</h3>
          <p>{manga.synopsis || 'No synopsis available.'}</p>
          {manga.background && (
            <div className="manga-background-info">
              <h4>Background</h4>
              <p>{manga.background}</p>
            </div>
          )}
        </div>

        <div className="manga-details-grid">
          {/* Direct implementation of DetailSection */}
          <div className="manga-detail-section">
            <h4>General Information</h4>
            {generalInfoDetails.map((detail, index) => (
              <div key={index} className="manga-detail-item">
                <span className="manga-label">{detail.label}</span>
                <span className="manga-value">{detail.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="manga-right-column">
        <div className="manga-content-tags">
          <MangaGenresSection genres={manga.genres || []} />
          <MangaThemesSection themes={manga.themes || []} />
        </div>
      </div>
    </div>
  );
};

export default MangaAbout;